import Vue from "vue";
import App from "./App.vue";
// import './registerServiceWorker'
import router from "./router";
import store from "./store";
import "./configs/bootstrap";
import i18n from "./configs/languages";
import Swal from "sweetalert2";

Vue.config.productionTip = false;

Vue.mixin({
    computed: {
      currentId() {
        return this.$route.params.id;
      }
    },
    methods: {
      isEdit() {
        return this.currentId !== "new";
      },
      goBack() {
        window.history.back();
      },
      reload() {
        window.location.reload();
      },
      errorHandler(err){
        let message = err.response.data.detail;
        console.log(err);
        return Swal.fire("Erro!", message || "Error", "error");
      },
      makeConfirm(title = "Do you really want to do this action?") {
        return Swal.fire({
          title,
          text: "You won't be able to revert this!",
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          confirmButtonText: "Ok",
          cancelButtonText: "Cancel"
        });
      }
    }
});

new Vue({
    router,
    store,
    i18n,
    render: h => h(App)
}).$mount("#app");
